import { useAppSelector } from '@/store/hooks';

export function useIsAuthenticated(): boolean {
  return useAppSelector((state) => state.auth.isAuthenticated);
}
